import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-collabo-portal-login',
  templateUrl: './collabo-portal-login.component.html',
  styleUrls: ['./collabo-portal-login.component.css'],
})
export class CollaboPortalLoginComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
